import axios from 'axios';

const state = {
    extendSessionInterval: null,
    extendLoginSessionInterval: null
};

const mutations = {
    setExtendSessionInterval(state, intervalId){
        state.extendSessionInterval = intervalId
    },
    setExtendLoginSessionInterval(state, intervalId){
        state.extendLoginSessionInterval = intervalId
    },
    clearSessionInterval(state) {
        state.extendSessionInterval = null;
    },
    clearLoginSessionInterval(state) {
        state.extendLoginSessionInterval = null;
    }
};

const actions = {
    createSession({ intervalId, commit, dispatch }, resourceId){
        const requestBody = {
            content: {
                id: resourceId
            }
        };

        axios.post(`/sessions`, requestBody)
            .then((resp) => {
                console.log('create-session', resp)
                let sessionId = resp.$data.id;
                dispatch('extendSession', sessionId)
            })

        commit('setExtendSessionInterval', intervalId);
    },

    extendSession({state, commit}, sessionId){
        if (state.extendSessionInterval) {
            clearInterval(state.extendSessionInterval);
            commit('clearSessionInterval')
        }

        const intervalId = setInterval(() => {
            axios.put(`/sessions/${sessionId}/extend`, null)
            .then((data) => {
                console.log('sessions', data);
            })
        }, 30 * 1000); 

        commit('setExtendSessionInterval', intervalId);
    },

    extendLoginSession({state, commit}, sessionId){
        if (state.extendLoginSessionInterval) {
            clearInterval(state.extendLoginSessionInterval);
            commit('clearLoginSessionInterval')
        }

        const intervalId = setInterval(() => {
            axios.put(`/login-sessions/${sessionId}/extend`, null)
            .then((data) => {
                console.log('login-session', data);
            })
        }, 30 * 1000); 

        commit('setExtendLoginSessionInterval', intervalId);
    },

    stopSessionExtension({state, commit}) {
        if (state.extendSessionInterval) {
            console.log("Clearing sessions interval now ..")
            clearInterval(state.extendSessionInterval);
            commit('clearSessionInterval');
        }
    },

    stopLoginSessionExtension({state, commit}) {
        if (state.extendSessionInterval) {
            console.log("Clearing login-session interval now ..")
            clearInterval(state.extendLoginSessionInterval);
            commit('clearLoginSessionInterval');
        }
    },
};

export default {
    namespace: 'sessions',
    namespaced: true,
    state,
    mutations,
    actions
};
